export default __webpack_public_path__ + "static/media/ic_albania.a69241c0.svg";